export default __webpack_public_path__ + "static/media/featured-homepage.9ca0ca58.png";